export default "__VITE_ASSET__BHoDCtfb__"